import { Injectable } from "@angular/core";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { Observable, map, mergeMap, switchMap, throwError } from "rxjs";
import { VersionRepo } from "@app/core/version/domain/version.repo";

@Injectable({ providedIn: "root" })
export class ShouldAppBeUpdatedUseCase {
  constructor(private versionRepo: VersionRepo) {}

  execute(): Observable<boolean> {
    //Only for testing
    this.versionRepo
      .getAppVersion()
      .pipe();

    return this.versionRepo
      .getMinimumVersion()
      .pipe(
        mergeMap((minVersion) =>
          this.versionRepo
            .getAppVersion()
            .pipe(map((appVersion) => minVersion.BUILD > appVersion.BUILD))
        )
      );
  }
}
